module.exports = __webpack_public_path__ + "static/img/case.87986ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/case.png
// module id = E+2g
// module chunks = 1